import { render, staticRenderFns } from "./ProductFrame.vue?vue&type=template&id=a2ff8eb2&scoped=true&"
import script from "./ProductFrame.vue?vue&type=script&lang=js&"
export * from "./ProductFrame.vue?vue&type=script&lang=js&"
import style0 from "./ProductFrame.vue?vue&type=style&index=0&id=a2ff8eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ff8eb2",
  null
  
)

export default component.exports